import { SimpleObjectInterface } from '@thewhite/react-global-module/lib/interfaces';
import { TypeService } from '@thewhite/react-global-module/lib/services';

export interface OktmoType {
    META: SimpleObjectInterface;
    LOCALITY: SimpleObjectInterface;
    MUNICIPALITY: SimpleObjectInterface;
    [value: string]: SimpleObjectInterface;
    SETTLEMENT_MUNICIPALITY: SimpleObjectInterface;
}

export enum OktmoTypeEnum {
    META = 'LOCALITY',
    LOCALITY = 'LOCALITY',
    MUNICIPALITY = 'MUNICIPALITY',
    SETTLEMENT_MUNICIPALITY = 'SETTLEMENT_MUNICIPALITY',
}

const OKTMO_TYPE: OktmoType = {
    MUNICIPALITY: {
        name: '',
        value: 'MUNICIPALITY',
    },
    SETTLEMENT_MUNICIPALITY: {
        name: '',
        value: 'SETTLEMENT_MUNICIPALITY',
    },
    LOCALITY: {
        name: '',
        value: 'LOCALITY',
    },
    META: {
        name: '',
        value: 'META',
    },
};

export default OKTMO_TYPE;

export const OktmoTypeEnumType = TypeService.createEnum<OktmoTypeEnum>(OktmoTypeEnum, 'OktmoTypeEnum');
